import route from "mock/route";

/**
 * 权限管理
 * @see https://umijs.org/docs/max/access#access
 * 
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    hasAdminAccess: currentUser?.permissions?.includes('Super Admin') || false,
    hasPartnerAccessDashboard: (route: any)=>{
      const partnerType = route.accessKey.split('_')[0];
      //-- 如果partner是resellers，但访问的页面是manufacturer的，也允许访问，两者公用一个模版
      if(currentUser?.partner_types.includes("resellers") && partnerType === "manufacturer"){
        return true;
      }
      if(partnerType && !currentUser?.partner_types.includes(partnerType)){
        return false;
      }
      const product = route.accessKey.split('_')[1];
      if(product && !currentUser?.products.includes(product)){
        return false;
      }
      return true;
    },
    hasProductAccessReport:(route: any)=>{
      const accesKeys = route.accessKey.split('_');
      const product = accesKeys.length > 1 ? accesKeys[1] : accesKeys[0];
      if(product && !currentUser?.products.includes(product)){
        return false;
      }
      return true;
    },
    hasReportApiAccess: (route: any) => {
      if(currentUser?.products.includes('AdSdk') || currentUser?.products.includes('DistributionOwn') ){
        return true;
      }
      return false;
    },
  };
}
